import { theme } from 'theme';
import { FlowConsignadoItemDTO } from '../detail/consignado-detail.model';
import { FlowConsignadoVisualizarNotasDTO } from '../movimentacoes/movimentacoes.model';

export type FlowConsignadoVisualizarDTO = {
    abaIdentificacao: FlowConsignadoVisualizarAbaIdentificacaoDTO;
    abaCliente: FlowConsignadoVisualizarAbaClienteDTO;
    abaProdutos: FlowConsignadoVisualizarAbaProdutosDTO;
    visualizarNotas: FlowConsignadoVisualizarNotasDTO;
    abaPedidos: FlowConsignadoVisualizarPedidosDTO;
};

export type FlowConsignadoVisualizarAbaIdentificacaoDTO = {
    numero: number;
    emissao: string;
    situacao: string;
    vendedor: string;
    deposito: string;
    tabelaPreco: string;
    motivoCancelamento: string;
    quantidadeAberta: number;
    quantidadeConsignada: number;
    quantidadeDevolvida: number;
    quantidadeVendida: number;
    quantidadeCancelada: number;
    saldo: number;
    valorAberto: number;
    valorConsignado: number;
};

export type FlowConsignadoVisualizarAbaClienteDTO = {
    nomeRazaoSocial: string;
    nomeFantasia: string;
    identificacao: string;
    inscricaoEstadual: string;
    pais: string;
    municipio: string;
    endereco: string;
    telefone: string;
    email: string;
};

export type FlowConsignadoVisualizarAbaProdutosDTO = {
    itens: FlowConsignadoVisualizarItemDTO[];
    quantidadeProdutos: string;
    quantidadeAberta: number;
    quantidadeConsignada: number;
    quantidadeDevolvida: number;
    quantidadeVendida: number;
    quantidadeCancelada: number;
    saldo: number;
    valorTotal: number;
};

export type FlowConsignadoVisualizarItemDTO = {
    descritivo: string;
    situacao: string;
    valorUnitario: number;
    percentualDesconto: number;
    valorDesconto: number;
    valorTotalLiquido: number;
    quantidadeAberta: number;
    quantidadeConsignada: number;
    quantidadeDevolvida: number;
    quantidadeVendida: number;
    quantidadeCancelada: number;
    saldo: number;
};

export type FlowConsignadoVisualizarPedidosDTO = {
    pedidos: FlowConsignadoVisualizarPedidoGeradoDTO[];
    quantidadePedidos: string;
};

export type FlowConsignadoVisualizarPedidoGeradoDTO = {
    id: number;
    uuid: string;
    numeroPedido: number;
    numeroEntrega: number;
    emissao: string;
    status: string;
    tipo: string;
    valorLiquido: number;
    itens: FlowConsignadoItemDTO[];
    quantidadeTotal: number;
    quantidadeDevolvida: number;
    quantidadeVendida: number;
    quantidadeCancelada: number;
    valorTotal: number;
};

export type ConsignadoVisualizarDialogProps = {
    uuidConsignado: string | null;
    open: boolean;
    onCloseVisualizarDialog: () => void;
};

export enum VisualizarTabs {
    IDENTIFICACAO = 'IDENTIFICACAO',
    CLIENTE = 'CLIENTE',
    PRODUTOS = 'PRODUTOS',
    CONSIGNACOES = 'CONSIGNACOES',
    DEVOLUCOES = 'DEVOLUCOES',
    PEDIDOS = 'PEDIDOS',
}

export enum VisualizarTabsDescritivo {
    IDENTIFICACAO = 'Identificação',
    CLIENTE = 'Cliente',
    PRODUTOS = 'Produtos',
    CONSIGNACOES = 'Consignações',
    DEVOLUCOES = 'Devoluções',
    PEDIDOS = 'Pedidos',
}

export type ConsignadoVisualizarDialogInitialState = {
    loading: boolean;
    screenLoading: boolean;
    selectedTab: VisualizarTabs;
    data: FlowConsignadoVisualizarDTO | null;
};

export const initialState: ConsignadoVisualizarDialogInitialState = {
    loading: true,
    screenLoading: false,
    selectedTab: VisualizarTabs.IDENTIFICACAO,
    data: null,
};

export const tabHeaderStyle = {
    '&.Mui-selected': {
        color: theme.palette.primary.main,
    },
    fontSize: 12,
    letterSpacing: 2,
    flexShrink: 0,
};

export const tabContentStyle = {
    minHeight: 'auto',
    padding: '24px 0 0 0',
};
